export default __webpack_public_path__ + "static/media/c-advanced.c43bf5d2.png";